import React, { useState } from 'react'
import { Box, Modal } from '@material-ui/core'
import {
  TextInput, Button, SimpleForm, Toolbar, FileInput, FileField, useDataProvider, useNotify,
} from 'react-admin'
import ChatIcon from '@material-ui/icons/Chat'
import PropTypes from 'prop-types'
import { ACTIONS } from '../providers/http/provider'

const subjectFieldId = 'subject'
const contentFieldId = 'content'
const attachmentsFieldId = 'attachments'

const ContactModalToolbar = ({ disabled }) => (
  <Toolbar style={{ backgroundColor: 'white', padding: '0 16px' }}>
    <Button
      style={{ width: '100%', height: '50px' }}
      type="submit"
      startIcon={<ChatIcon />}
      label="Envoyer"
      disabled={disabled}
    />
  </Toolbar>
)

const ContactModal = ({ open, handleClose, receiver }) => {
  const [canSubmit, setCanSubmit] = useState(false)
  const dataProvider = useDataProvider()
  const notify = useNotify()

  async function sendMessage(event) {
    event.preventDefault()

    // Get the field values
    const subject = document.getElementById(subjectFieldId).value
    const content = document.getElementById(contentFieldId).value
    const rawAttachments = Array.from(document.getElementById(attachmentsFieldId).files)

    // Get the files in base64 and build attachement ojbects
    const attachments = await Promise.all(
      rawAttachments.map(async (rawFile) => {
        const base64File = await toBase64(rawFile)
        // Get only file content (after the ,)
        const base64FileContent = base64File.split(',')[1]
        return {
          name: rawFile.name,
          type: rawFile.type,
          content: base64FileContent,
        }
      })
    )

    // Make the post to make the backend send the message
    dataProvider(ACTIONS.CREATE, `contact?receiver=${receiver}`, { data: { subject, content, attachments } })
      .then(() => notify('Le message a bien été envoyé !', 'info'))
      .catch((error) => notify(`Une erreur est survenue, le message n'a pas pu être envoyé : ${error}`, 'error'))

    handleClose()
  }

  function toBase64(rawFile) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(rawFile)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }

  function validateForm(values) {
    const errors = {}

    if (!values.subject) {
      errors.subject = "Veuillez remplir l'objet du message"
    }
    if (!values.content) {
      errors.content = 'Veuillez remplir le contenu du message'
    }

    // We can submit only if the form data is validated
    setCanSubmit(Object.keys(errors).length === 0)

    return errors
  }

  function getReceiverName() {
    switch (receiver) {
      case 'PLAYERS':
        return 'Contacter les joueurs'
      case 'ORGANISERS':
        return 'Contacter les organisateurs'
      case 'CLUBS':
        return 'Contacter les clubs'
      default:
        return 'Contacter les utilisateurs'
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      style={{
        position: 'fixed',
        zIndex: 1300,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        style={{
          backgroundColor: 'white',
          borderRadius: 8,
          padding: 24,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 600,
        }}
      >
        <h2 style={{ color: 'rgba(0, 0, 0, 0.87)', fontWeight: '400', padding: '0 16px' }}>{getReceiverName()}</h2>
        <SimpleForm
          style={{ padding: 0 }}
          toolbar={<ContactModalToolbar disabled={!canSubmit} />}
          validate={validateForm}
          onSubmitCapture={sendMessage}
        >
          <TextInput id={subjectFieldId} label="Objet du message" source={subjectFieldId} fullWidth />
          <TextInput
            id={contentFieldId}
            label="Contenu du message"
            source={contentFieldId}
            fullWidth
            multiline
            minRows={10}
          />
          <FileInput
            id={attachmentsFieldId}
            multiple
            source={attachmentsFieldId}
            label="Pièces jointes"
            accept=".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.documen, application/pdf, image/*"
            placeholder={<p>Sélectionnez les pièces jointes</p>}
          >
            <FileField source="src" title="title" />
          </FileInput>
        </SimpleForm>
      </Box>
    </Modal>
  )
}

ContactModal.prototype = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  receiver: PropTypes.oneOf(['PLAYERS', 'ORGANISERS', 'CLUBS']),
}

export default ContactModal
